export const iconFontAwesomeDevicesHardwareTv = (
	<i className="fa-solid fa-tv"></i>
);
